export enum BuyerMeteringsActionTypes {
  SET_BUYER_METERINGS = 'SET_BUYER_METERINGS',
}

export type DimensionWiseMetering = {
  name: string
  description: string | null
  price: number
  quantity: number
  totalAmount: number
}

export type Metering = {
  meteringCount: number
  lastMeteringDate: string
  lastMeteringStatus: string
  lastMeteringAmount: number
  offerName: string | null
  productName: string
  productId: string
  subscriptionStatus: string
  subscriptionId: string
  growthRatePercent: number
  dimensionWiseMetering: DimensionWiseMetering[]
}

export interface Meterings {
  meterings: Metering[]
}

export const initialBuyerMeteringsState: Meterings = {
  meterings: [],
}

export type BuyerMeteringsAction = {
  type: BuyerMeteringsActionTypes.SET_BUYER_METERINGS
  payload: Meterings
}
